export default __webpack_public_path__ + "static/media/Initiate's Belt of Twining Smoke.0835341d.jpg";